// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"18737a84","425":"5b08cd17","510":"725325ff","532":"414d80e7","633":"9c22b8ed","634":"492e7ef7","922":"7e69ccb0","937":"13a1cbc6","972":"48d5d266"}[chunkId] + ".chunk.js";
};